"use client";

import { useEffect } from "react";
import { GlassStatusCard } from "@/components/ui/glass-status-card";
import { reportErrorBoundary } from "@/lib/sentry-error-boundary";
interface GlobalErrorProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
const isPostHogEnabled = Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY) && (process.env.NEXT_PUBLIC_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV) === "production";
export default function GlobalError({
  error,
  reset
}: GlobalErrorProps) {
  useEffect(() => {
    console.error("Global error boundary caught:", error);
    reportErrorBoundary(error, "global", {
      digest: error.digest
    });
    void (async () => {
      if (!isPostHogEnabled) {
        return;
      }
      try {
        const posthog = (await import("posthog-js")).default;
        posthog?.capture?.("global_error_boundary", {
          digest: error.digest ?? null,
          message: error.message
        });
      } catch (telemetryError) {
        console.error("[GlobalError] PostHog telemetry failed:", telemetryError);
      }
    })();
  }, [error]);
  return <html lang="en" data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        <GlassStatusCard hardNavigate eyebrow="Global error" title="Application error" description="A global error occurred. You can retry or return home." devDetail={process.env.NODE_ENV === "development" ? error.message : undefined} actions={[{
        label: "Try again",
        onClick: reset,
        variant: "primary"
      }, {
        label: "Go home",
        href: "/",
        variant: "secondary"
      }]} data-sentry-element="GlassStatusCard" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>;
}